function orderAgain(orderCode) {
    var token = $("input[name='_csrf']").val();
    var header = "X-CSRF-TOKEN";
    $.ajax({
        url: "/my-account/order/" + orderCode,
        type: 'POST',
        beforeSend: function (xhr) {
            xhr.setRequestHeader(header, token);
        },
        success: function (response, textStatus, xhr) {
            var suggestions = response.suggestions;
            if( (typeof suggestions === 'undefined') || JSON.stringify(suggestions) == "{}"){
                 document.location.href = "/cart";
            }else{
                let safeOrderCode = orderCode.replace(/%23/g, '\\%23');
                $("#my-account-missing-product-"+safeOrderCode+"-info").show();
                Object.keys(suggestions).forEach(function (k) {
                    var suggestionValue = suggestions[k];
                    var safeOrderEntryId = k.replace(/:/g, '\\:');
                     if(!suggestionValue || (typeof suggestionValue === 'undefined') || JSON.stringify(suggestionValue) == "{}"){
                         $("#my-account-missing-product-"+ safeOrderCode + "-"+ safeOrderEntryId).show();
                     }else{
                        $("#my-account-suggested-product-"+ safeOrderCode + "-"+ safeOrderEntryId +"-link").prop("href",suggestions[k]);
                        $("#my-account-suggested-product-"+ safeOrderCode + "-"+ safeOrderEntryId).show();

                     }
                     $("#my-account-missing-product-"+safeOrderCode+"-info").show();
                });
           }
        }
    });
};
